import { render, staticRenderFns } from "./tabs-edit.vue?vue&type=template&id=2e8c016c&scoped=true&"
import script from "./tabs-edit.vue?vue&type=script&lang=js&"
export * from "./tabs-edit.vue?vue&type=script&lang=js&"
import style0 from "./tabs-edit.vue?vue&type=style&index=0&id=2e8c016c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c016c",
  null
  
)

export default component.exports